import type {
  PurchasingProductsParams,
  PurchasingProductsResponse,
  PurchasingPurchaseLinesParams,
  PurchasingVendorItemsParams,
} from '@/services/purchasing'
import {
  listPurchasingProducts,
  listPurchasingPurchaseLines,
  listPurchasingVendorItems,
} from '@/services/purchasing'

const PAGE_LIMIT = 200

async function fetchAllPages<T>(
  fetchPage: (cursor?: string) => Promise<{ rows: T[]; next_cursor: string | null }>,
): Promise<T[]> {
  const rows: T[] = []
  let cursor: string | undefined
  for (;;) {
    const page = await fetchPage(cursor)
    rows.push(...page.rows)
    if (!page.next_cursor) break
    cursor = page.next_cursor
  }
  return rows
}

export async function fetchAllPurchasingProducts(
  params?: Omit<PurchasingProductsParams, 'cursor' | 'limit'>,
): Promise<PurchasingProductsResponse['rows']> {
  return fetchAllPages((cursor) =>
    listPurchasingProducts({ ...params, cursor, limit: PAGE_LIMIT }),
  )
}

export async function fetchAllPurchasingVendorItems(
  params?: Omit<PurchasingVendorItemsParams, 'cursor' | 'limit'>,
): Promise<Awaited<ReturnType<typeof listPurchasingVendorItems>>['rows']> {
  return fetchAllPages((cursor) =>
    listPurchasingVendorItems({ ...params, cursor, limit: PAGE_LIMIT }),
  )
}

export async function fetchAllPurchasingPurchaseLines(
  params: Omit<PurchasingPurchaseLinesParams, 'cursor' | 'limit'>,
): Promise<Awaited<ReturnType<typeof listPurchasingPurchaseLines>>['rows']> {
  return fetchAllPages((cursor) =>
    listPurchasingPurchaseLines({ ...params, cursor, limit: PAGE_LIMIT }),
  )
}
